

export const RouteNames = {
  // ─── Auth / Signup ──────────────────────────────────────────────────────
  SIGN_IN: '/customer-login',
  SIGN_UP: '/customer-signup',
  SIGN_UP_EMAIL_PASSWORD_INFO: '/customer-signup/details',
  SIGN_UP_CONTACT_INFO: '/customer-signup/contact-info',
  SIGN_UP_PREFERENCES: '/customer-signup/preferences',
  SIGN_UP_REFERRAL_CODE: '/customer-signup/referral-code',
  SIGN_UP_PRIVACY_POLICY: '/customer-signup/privacy-policy',
  FORGOT_PASSWORD: '/customer-forgot-password',

  // ─── Payment / Post-signup ──────────────────────────────────────────────
  SUCCESSFUL_SIGN_UP: '/customer-signup/success',
  PAYMENT_FORM: '/customer-payment',
  FREE_PREMIUM: '/customer-payment/free-premium',
  REFERRAL_PROGRAM_FORM: '/customer-payment/referral-program',

  // ─── Home / core nav ────────────────────────────────────────────────────
  HOME: '/home',
  GUEST_HOME: '/',
  LOCATION_SEARCH: '/location-search',

  // ─── Coupons ─────────────────────────────────────────────────────────────
  COUPONS_LISTS_ALL: '/coupons-list',
  COUPONS_MAPS_ALL: '/coupons-map',
  COUPONS_DETAILS: '/coupons-detail',
  COUPONS_APPLY: '/coupons-apply',
  COUPONS_RESERVED: '/coupons-reserved',
  FAVOURITES: '/favourites',
  CATEGORY_SEARCH: '/category-search',
  ONBOARDING: '/onboarding',
  DEALS_BY_CITY: '/deals',

  // ─── Businesses ──────────────────────────────────────────────────────────
  BUSINESSES_DETAILS: '/business-detail',
  AFFILIATE_BUSINESS_DETAILS: '/online-brand-detail',
  BUSINESSES_LIST_ALL: '/businesses-list',
  BUSINESSES_LIST_SEARCH: '/businesses-search',
  BUSINESSES_LIST_RECOMMENDED: '/businesses-recommended',
  BUSINESSES_FOLLOWED: '/businesses-followed',
  AFFILIATE_BUSINESSES_LIST_ALL: '/online-brands-list',

  // ─── Blog ──────────────────────────────────────────────────────────
  BLOGS: '/blogs',
  BLOG_DETAILS: '/blogs/:id',

  // ─── Account ─────────────────────────────────────────────────────────────
  ACCOUNT: '/my-account',
  PREFERENCES: '/preferences',
  DELETE_ACCOUNT: '/my-account/delete',

  // ─── Used coupons / referrals ────────────────────────────────────────────
  USED_COUPONS_HISTORY: '/used-coupons/history',
  USED_COUPONS_RESERVED: '/used-coupons/reserved',
  REFERRALS_BUSINESSES: '/referrals/businesses',
  REFERRALS_CUSTOMERS: '/referrals/customers',

  // ─── Legal ───────────────────────────────────────────────────────────────
  PRIVACY_POLICY: '/customer-privacy-policy',
  TERMS_OF_SERVICE: '/customer-terms-of-service',
};

export default RouteNames;